/*@flow*/
// @ts-check
/** @jsx jsx */
import { jsx } from '@emotion/core';
import useContextState from 'comps/Left2/useContextState';
import useCommands from 'comps/Left2/useCommands';
import ResourceModal from 'comps/ResourceBuilder/Modal';

export function ResourceModalContainer() {
  const s = useContextState();
  const cmd = useCommands();
  const { locActiveModalName } = s;
  const isOpen = locActiveModalName === 'NEW_RECORD';

  return (
    <ResourceModal
      isOpen={isOpen}
      onClose={() => {
        cmd.set(['locActiveModalName'], '');
      }}
    />
  );
}
